var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "category-wrapper" },
    _vm._l(_vm.categories, function (category) {
      return _c(
        "span",
        { staticClass: "category" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: category === _vm.activeCategory ? "primary" : "text",
              },
              on: {
                click: function ($event) {
                  return _vm.clickCategory(category)
                },
              },
            },
            [_vm._v(_vm._s(category.name))]
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }